<template>
    <div class="content min-vh-100 flex-column d-flex justify-content-between">
        <section>
            <h2 class="title">
                Claim n° {{ claimId }}
            </h2>
            <hr />
            <div class="row">
                <div class="col">
                    <h3>Your request has been correctly received by the Insurer</h3>
                    <p>
                        You will soon be contacted by e-mail by the Claims Department of {{ this.$strings.partner }}. 
                        You will be required to provide all documents needed to process the claim as required under the policy visible <download what="terms_and_conditions"/>
                    </p>
                    <p>
                        For a list of documents to be provided for each type of claim, visit <router-link to="/claim-documentation">this page</router-link>
                    </p>
                    <!-- <p>
                        Read carefully the complete Terms and Conditions <download what="terms_and_conditions"/>
                    </p> -->
                </div>
            </div>
            <!-- 
            <div class="row">
                <div class="col">
                    <h3 class="font-italic">Please prepare the following documents to complete your claim</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt:
                    </p>
                    <ul class="list">
                        <li>Lorem ipsum</li>
                        <li>Lorem ipsum</li>
                        <li>Lorem ipsum</li>
                        <li>Lorem ipsum</li>
                    </ul>
                </div>
            </div> 
            -->
        </section>
        <!-- 
        <section class="fixed-bottom text-center">
            <p class="font-italic">Read all the terms of conditions</p>
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#pdfModal">
                Policy conditions Pdf
            </button>
        </section>
        -->
    </div>
</template>

<script>
export default {
    computed: {
        claimId(){
            return this.$route.params.claimId
        }
    }
}
</script>